// import { Component, Fragment } from "react";
// import { Link } from "react-router-dom";

// import AppItem from "../Components/AppItem";
// import TabItem from "../Components/TabItem";


// import "../AppStore.css";

// const SEARCH_ICON_URL =
//   "https://assets.ccbp.in/frontend/react-js/app-store/app-store-search-img.png";

// const tabsList = [
//   { tabId: "CIVIL & ARCHITECTURE CAD", displayText: "Civil & Architecture" },
//   { tabId: "MECHANICAL CAD", displayText: "Mechanical" },
//   // { tabId: "ARCHITECTURE CAD", displayText: "Architecture" },
//   { tabId: "ELECTRICAL CAD", displayText: "Electrical" },
//   { tabId: "IT COURSES", displayText: "IT Courses" },
//   { tabId: "INTERIOR & BIM", displayText: "Interior & BIM" }

// ];

// const appsList = [
//   {
//     appId: 0,
//     appName: "Auto Cad",
//     imageUrl: "img/Autop.jpg",
//     category: "MECHANICAL CAD",
//     description:
//       "Auto Cad software application widely used for creating 2D and 3D drawings and models",
//     link: "/Autocad",
//   },
//   {
//     appId: 1,
//     appName: "Solid Work",
//     imageUrl: "img/Solidp.jpg",
//     category: "MECHANICAL CAD",
//     description: "3D CAD software for parametric design and simulation",
//     link: "/Solidworks",
//   },
//   {
//     appId: 2,
//     appName: "Catia",
//     imageUrl: "img/Catiap.jpg",
//     category: "MECHANICAL CAD",
//     description:
//       "Catia Advanced CAD software for product design and engineering",
//     link: "/Catia",
//   },
//   {
//     appId: 3,
//     appName: "Nx Cad",
//     imageUrl: "img/Nxcadp.jpg",
//     category: "MECHANICAL CAD",
//     description:
//       "Nx cad Integrated CAD/CAM/CAE software for product development.",
//     link: "/Nx Cad",
//   },
//   {
//     appId: 4,
//     appName: "Ansys",
//     imageUrl: "img/Ansysp.jpg",
//     category: "MECHANICAL CAD",
//     description:
//       "The ansys used for engineering simulation, encompassing finite element analysis",
//     link: "/Ansys",
//   },
//   // {
//   //   appId: 5,
//   //   appName: "Creo",
//   //   imageUrl: "img/Creop.jpg",
//   //   category: "MECHANICAL CAD",
//   //   description:
//   //     "The creo Parametric 3D CAD software with a focus on product development",
//   //   link: "/Creo",
//   // },
//   {
//     appId: 6,
//     appName: "Fusion 360",
//     imageUrl: "img/Fusionp.jpg",
//     category: "MECHANICAL CAD",
//     description:
//       "The fusion 360 Cloud-based CAD/CAM/CAE tool for collaborative design",
//     link: "/Fusion",
//   },
//   // {
//   //   appId: 7,
//   //   appName: "GD&T",
//   //   imageUrl: "img/gd&t.jpg",
//   //   category: "MECHANICAL CAD",
//   //   description:
//   //     "Standardized symbolic language for specifying and communicating",
//   //   link: "/Gd&t",
//   // },
//   // {
//   //   appId: 8,
//   //   appName: "Inventer",
//   //   imageUrl: "img/Inventerp.jpg",
//   //   category: "MECHANICAL CAD",
//   //   description: "Autodesk's 3D mechanical design and simulation software",
//   //   link: "/Inventer",
//   // },
//   {
//     appId: 9,
//     appName: "AutoCAD Civil/Arch.",
//     imageUrl: "img/ACAD.jpg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "AutoCAD is a powerful drafting software used to create precise 2D Drawings and 3D Models.",
//     link: "/AutocaCivilArch",
//   },
//   {
//     appId: 10,
//     appName: "Civil 3D",
//     imageUrl: "img/autodeskcivil.jpg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "Civil 3D is used to create three-dimensional (3D) models of land, water, or transportation features",
//     link: "/AutodeskCivil3d",
//   },
//   {
//     appId: 11,
//     appName: "Staad Pro",
//     imageUrl: "img/Staadp.jpg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "Civil engineering design and documentation software with BIM capabilities.",
//     link: "/Staadpro",
//   },
//   {
//     appId: 12,
//     appName: "Etabs",
//     imageUrl: "img/ETABp.jpg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "Structural analysis and design software for buildings and structures",
//     link: "/Etabs",
//   },
//   // {
//   //   appId: 13,
//   //   appName: "V-rays",
//   //   imageUrl: "img/Vrayp.jpg",
//   //   category: "CIVIL & ARCHITECTURE CAD",
//   //   description:
//   //     "Photorealistic rendering plugin widely used with 3D modeling software for lifelike visualizations.",
//   //   link: "/V-ray",
//   // },
//   {
//     appId: 14,
//     appName: "3DS-Max",
//     imageUrl: "img/Max3dp.jpg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "3D modeling and animation software for creating stunning visual content.",
//     link: "/Civil3d",
//   },
//   {
//     appId: 15,
//     appName: "Lumion",
//     imageUrl: "img/Lumiop.jpg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "Real-time architectural visualization software for creating compelling, immersive renderings.",
//     link: "/Lumion",
//   },
//   {
//     appId: 16,
//     appName: "SketchUp",
//     imageUrl: "img/googlep.jpeg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "Intuitive 3D modeling software for conceptual design and visualization.",
//     link: "/GoogleSketchup",
//   },
//   // {
//   //   appId: 17,
//   //   appName: "Auto Cad Arch",
//   //   imageUrl: "img/Autop.jpg",
//   //   description:
//   //     "Specialized CAD software for architectural design and drafting",
//   //   category: "CIVIL & ARCHITECTURE CAD",
//   // },
//   {
//     appId: 18,
//     appName: "Revit Arch",
//     imageUrl: "img/Revitap.jpg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "empowering architects to design, visualize, and document building projects",
//     link: "/Revit Architecture",
//   },
//   {
//     appId: 19,
//     appName: "Revit Structure",
//     imageUrl: "img/Revitsp.jpg",
//     category: "CIVIL & ARCHITECTURE CAD",
//     description:
//       "BIM-based software for structural design and documentation in building projects.",
//     link: "/Revit Structure",
//   },
   
//   // {
//   //   appId: 20,
//   //   appName: "PhotoShop",
//   //   imageUrl: "img/photoshop.jpg",
//   //   category: "IT COURSES",
//   //   description:
//   //     "Graphic design software used for enhancing and editing images, including architectural visualizations.",
//   //   link: "/PhotoShop",
//   // },

//     {
//     appId: 21,
//     appName: "MEP",
//     imageUrl: "img/MEP.jpg",
//     category: "MECHANICAL CAD",
//     description:
//       "Works on BIM and used for planning & installing HVAC, electrical & Plumbing in buildings.",
//     link: "/Mep",
//   },
//    {
//     appId: 22,
//     appName: "CNC",
//     imageUrl: "img/CNC.jpg",
//     category: "MECHANICAL CAD",
//     description:
//       "CNC Programming is the manual coding done by G-codes and M-codes for machining.",
//     link: "/Cnc",
//   },

//     {
//     appId: 23,
//     appName: "Auto Cad",
//     imageUrl: "img/acd_el.jpg",
//     category: "ELECTRICAL CAD",
//     description:
//       "Most powerful programs have commands like wiring, circuiting, PLC modules, panels, and more.",
//     link: "/Autocadelectrical",
//   },

//     {
//     appId: 24,
//     appName: "Matlab",
//     imageUrl: "img/MATLAB-1.jpg",
//     category: "ELECTRICAL CAD",
//     description:
//       "Used by engineers and scientists for iterative analysis and design processes.",
//     link: "/Matlabelectrical",
//   },

//       {
//     appId: 25,
//     appName: "PLC",
//     imageUrl: "img/PLC-1.jpg",
//     category: "ELECTRICAL CAD",
//     description:
//       "(PLCs) are one of the most useful technologies in the industries for automation.",
//     link: "/Plc",
//   },
//    {
//     appId: 26,
//     appName: "Fullstack Developer",
//     imageUrl: "img/full-stack.jpg",
//     category: "IT COURSES",
//     description:
//       "To design and develop web-based, network-centric or enterprise applications",
//     link: "/Fullstack",
//   },
//    {
//     appId: 27,
//     appName: "Cyber Security",
//     imageUrl: "img/Cyber-Security.jpg",
//     category: "IT COURSES",
//     description:
//       "It is the practice of defending computers and servers, mobile devices, etc from malicious attacks",
//     link: "/CyberSecurity",
//   },

//   {
//   appId: 28,
//   appName: "BIM",
//   imageUrl: "img/bim.jfif",  
//   category: "INTERIOR & BIM",
//  description:"BIM training with Revit Architecture, Structure & MEP and practical 3D modeling.",
//   link: "/civil-architecture",  
// },
// {
//   appId: 29,
//   appName: "Interior Design",
//   imageUrl: "img/interior-designing.webp",
//   category: "INTERIOR & BIM",
//   description:
//     "Interior design training with AutoCAD, SketchUp, 3ds Max, V-Ray & Lumion for 2D drafting and 3D visualization.",
//   link: "/civil-design",
// },

// ///my changes
// {
//   appId: 30,
//   appName: "C Programming",
//   imageUrl: "img/programming.jpg",
//   category: "IT COURSES",
//   description: "Learn programming concepts, logic building, and software development using modern programming languages.",
//   link: "/CProgramming"
// },
// {
//   appId: 31,
//   appName: "Accounting",
//   imageUrl: "img/accounting.jpg",
//   category: "IT COURSES",
//   description: "Learn accounting fundamentals including bookkeeping, financial statements, and accounting software.",
//   link: "/Accounting"
// },
// {
//   appId: 32,
//   appName: "Graphic Design",
//   imageUrl: "img/graphic-design.jpg",
//   category: "IT COURSES",
//   description: "Learn visual communication, typography, color theory, and digital design tools.",
//   link: "/GraphicDesign"
// },
// {
//   appId: 33,
//   appName: "Data Visualisation",
//   imageUrl: "img/data-visualisation.jpg",
//   category: "IT COURSES",
//   description: "Learn how to represent data visually using charts, dashboards, and data analytics tools.",
//   link: "/DataVisualisation"
// },
// {
//   appId: 34,
//   appName: "Software Testing",
//   imageUrl: "img/software-testing.jpg",
//   category: "IT COURSES",
//   description: "Understand software testing methodologies including manual and automated testing techniques.",
//   link: "/SoftwareTesting"
// },
// {
//   appId: 35,
//   appName: "Web Development",
//   imageUrl: "img/web-development.png",
//   category: "IT COURSES",
//   description: "Learn how to build modern websites using HTML, CSS, JavaScript and backend technologies.",
//   link: "/WebDevelopment"
// },
// {
//   appId: 36,
//   appName: "Database Management",
//   imageUrl: "img/database-management.png",
//   category: "IT COURSES",
//   description: "Learn database design, SQL queries, data storage, and management of relational databases.",
//   link: "/DatabaseManagement"
// },
// {
//   appId: 37,
//   appName: "UI & UX",
//   imageUrl: "img/ui-ux.jpg",
//   category: "IT COURSES",
//   description: "Learn user interface and user experience design principles to create user-friendly digital products.",
//   link: "/UIUX"
// },
// {
//   appId: 38,
//   appName: "PhotoShop",
//   imageUrl: "img/photoshop.jpg",
//   category: "IT COURSES",
//   description: "Graphic design software used for enhancing and editing images, including architectural visualizations.",
//   link: "/PhotoShop"
// },
// {
//   appId: 39,
//   appName: "Corel Draw",
//   imageUrl: "img/corel-draw.avif",
//   category: "IT COURSES",
//   description: "Learn vector graphic design, illustration, and professional layout design using CorelDraw.",
//   link: "/CorelDraw"
// },
// {
//   appId: 40,
//   appName: "Canva",
//   imageUrl: "img/canva.webp",
//   category: "IT COURSES",
//   description: "Create professional graphics, social media designs, and presentations using Canva.",
//   link: "/Canva"
// },
// {
//   appId: 41,
//   appName: "CSS",
//   imageUrl: "img/css.png",
//   category: "IT COURSES",
//   description: "Learn Cascading Style Sheets to design responsive and visually appealing websites.",
//   link: "/CSS"
// },
// {
//   appId: 42,
//   appName: "Figma",
//   imageUrl: "img/figma.avif",
//   category: "IT COURSES",
//   description: "Learn interface design, prototyping, and collaborative design using Figma.",
//   link: "/Figma"
// },
// {
//   appId: 43,
//   appName: "HTML 5",
//   imageUrl: "img/html5.png",
//   category: "IT COURSES",
//   description: "Learn HTML5 to build structured and semantic web pages for modern websites.",
//   link: "/HTML5"
// },
// {
//   appId: 44,
//   appName: "C++ Programming",
//   imageUrl: "img/cpp.jpg",
//   category: "IT COURSES",
//   description: "Learn object-oriented programming, data structures, and application development using C++.",
//   link: "/CppProgramming"
// },
// {
//   appId: 45,
//   appName: "C# Programming",
//   imageUrl: "img/csharp.jpg",
//   category: "IT COURSES",
//   description: "Learn C# programming for building desktop applications, web applications, and .NET software.",
//   link: "/CSharpProgramming"
// }
// ];

// class AppStore extends Component {
//   state = {
//     searchInput: "",
//     activeTabId: tabsList[0].tabId,
//   };

//   setActiveTabId = (tabId) => {
//     this.setState({ activeTabId: tabId });
//   };

//   onChangeSearchInput = (event) => {
//     this.setState({ searchInput: event.target.value });
//   };

//   getActiveTabApps = (searchedApps) => {
//     const { activeTabId } = this.state;
//     const filteredApps = searchedApps.filter(
//       (eachSearchedApp) => eachSearchedApp.category === activeTabId
//     );

//     return filteredApps;
//   };

//   getSearchResults = () => {
//     const { searchInput } = this.state;
//     const searchResults = appsList.filter((eachApp) =>
//       eachApp.appName.toLowerCase().includes(searchInput.toLowerCase())
//     );

//     return searchResults;
//   };

//   render() {
//     const { searchInput, activeTabId } = this.state;
//     const searchResults = this.getSearchResults();
//     const filteredApps = this.getActiveTabApps(searchResults);

//     return (
//       <Fragment>
//         <div>
//           <img
//             src="img/footer1.jpg"
//             alt="Slide Image"
//             className="img-fluid w-100"
//             style={{ height: "300px", Width: "800px" }}
//           />
//           <nav aria-label="breadcrumb" className="mt-3">
//             <ol className="breadcrumb">
//               <li className="breadcrumb-item">
//                 <Link to="/home">Home</Link>
//               </li>
//               <li className="breadcrumb-item active" aria-current="page">
//                 Courses
//               </li>
//             </ol>
//           </nav>
//         </div>

//         <div className="app-container py-1" style={{ marginTop: "-50px" }}>
//           <div className="app-store">
//             <h1 className="heading">CAD COURSES</h1>
//             <div className="search-input-container">
//               <input
//                 type="search"
//                 placeholder="Search"
//                 className="search-input"
//                 value={searchInput}
//                 onChange={this.onChangeSearchInput}
//               />
//               <img
//                 src={SEARCH_ICON_URL}
//                 alt="search icon"
//                 className="search-icon"
//               />
//             </div>
//             <ul className="tabs-list">
//               {tabsList.map((eachTab) => (
//                 <TabItem
//                   key={eachTab.tabId}
//                   tabDetails={eachTab}
//                   setActiveTabId={this.setActiveTabId}
//                   isActive={activeTabId === eachTab.tabId}
//                 />
//               ))}
//             </ul>
//             <ul className="apps-list">
//               {filteredApps.map((eachApp) => (
//                 <AppItem key={eachApp.appId} appDetails={eachApp} />
//               ))}
//             </ul>
//           </div>
//         </div>
//       </Fragment>
//     );
//   }
// }

// export default AppStore;


import { Component, Fragment } from "react";
import { Link } from "react-router-dom";

import AppItem from "../Components/AppItem";
import TabItem from "../Components/TabItem";

import "../AppStore.css";

// HOC to inject location into class component
import { useLocation } from "react-router-dom";

const SEARCH_ICON_URL =
  "https://assets.ccbp.in/frontend/react-js/app-store/app-store-search-img.png";

const tabsList = [
  { tabId: "IT COURSES", displayText: "IT Courses" },
  { tabId: "CIVIL & ARCHITECTURE CAD", displayText: "Civil & Architecture" },
  { tabId: "MECHANICAL CAD", displayText: "Mechanical" },
  { tabId: "ELECTRICAL CAD", displayText: "Electrical" },
  
  { tabId: "INTERIOR & BIM", displayText: "Interior & BIM" },
];

const appsList = [
  {
    appId: 0,
    appName: "Auto Cad",
    imageUrl: "img/Autop.webp",
    category: "MECHANICAL CAD",
    description:
      "Auto Cad software application widely used for creating 2D and 3D drawings and models",
    link: "/Autocad",
  },
  {
    appId: 1,
    appName: "Solid Work",
    imageUrl: "img/Solidp.webp",
    category: "MECHANICAL CAD",
    description: "3D CAD software for parametric design and simulation",
    link: "/Solidworks",
  },
  {
    appId: 2,
    appName: "Catia",
    imageUrl: "img/Catiap.webp",
    category: "MECHANICAL CAD",
    description:
      "Catia Advanced CAD software for product design and engineering",
    link: "/Catia",
  },
  {
    appId: 3,
    appName: "Nx Cad",
    imageUrl: "img/Nxcadp.webp",
    category: "MECHANICAL CAD",
    description:
      "Nx cad Integrated CAD/CAM/CAE software for product development.",
    link: "/Nx Cad",
  },
  {
    appId: 4,
    appName: "Ansys",
    imageUrl: "img/Ansysp.webp",
    category: "MECHANICAL CAD",
    description:
      "The ansys used for engineering simulation, encompassing finite element analysis",
    link: "/Ansys",
  },
  {
    appId: 6,
    appName: "Fusion 360",
    imageUrl: "img/Fusionp.webp",
    category: "MECHANICAL CAD",
    description:
      "The fusion 360 Cloud-based CAD/CAM/CAE tool for collaborative design",
    link: "/Fusion",
  },
  {
    appId: 9,
    appName: "AutoCAD Civil/Arch.",
    imageUrl: "img/ACAD.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "AutoCAD is a powerful drafting software used to create precise 2D Drawings and 3D Models.",
    link: "/AutocaCivilArch",
  },
  {
    appId: 10,
    appName: "Civil 3D",
    imageUrl: "img/autodeskcivil.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "Civil 3D is used to create three-dimensional (3D) models of land, water, or transportation features",
    link: "/AutodeskCivil3d",
  },
  {
    appId: 11,
    appName: "Staad Pro",
    imageUrl: "img/Staadp.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "Civil engineering design and documentation software with BIM capabilities.",
    link: "/Staadpro",
  },
  {
    appId: 12,
    appName: "Etabs",
    imageUrl: "img/ETABp.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "Structural analysis and design software for buildings and structures",
    link: "/Etabs",
  },
  {
    appId: 14,
    appName: "3DS-Max",
    imageUrl: "img/Max3dp.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "3D modeling and animation software for creating stunning visual content.",
    link: "/Civil3d",
  },
  {
    appId: 15,
    appName: "Lumion",
    imageUrl: "img/Lumiop.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "Real-time architectural visualization software for creating compelling, immersive renderings.",
    link: "/Lumion",
  },
  {
    appId: 16,
    appName: "SketchUp",
    imageUrl: "img/googlep.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "Intuitive 3D modeling software for conceptual design and visualization.",
    link: "/GoogleSketchup",
  },
  {
    appId: 18,
    appName: "Revit Arch",
    imageUrl: "img/Revitap.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "empowering architects to design, visualize, and document building projects",
    link: "/Revit Architecture",
  },
  {
    appId: 19,
    appName: "Revit Structure",
    imageUrl: "img/Revitsp.webp",
    category: "CIVIL & ARCHITECTURE CAD",
    description:
      "BIM-based software for structural design and documentation in building projects.",
    link: "/Revit Structure",
  },
  {
    appId: 21,
    appName: "MEP",
    imageUrl: "img/MEP.webp",
    category: "MECHANICAL CAD",
    description:
      "Works on BIM and used for planning & installing HVAC, electrical & Plumbing in buildings.",
    link: "/Mep",
  },
  {
    appId: 22,
    appName: "CNC",
    imageUrl: "img/CNC.webp",
    category: "MECHANICAL CAD",
    description:
      "CNC Programming is the manual coding done by G-codes and M-codes for machining.",
    link: "/Cnc",
  },
  {
    appId: 23,
    appName: "Auto Cad",
    imageUrl: "img/acd_el.webp",
    category: "ELECTRICAL CAD",
    description:
      "Most powerful programs have commands like wiring, circuiting, PLC modules, panels, and more.",
    link: "/Autocadelectrical",
  },
  {
    appId: 24,
    appName: "Matlab",
    imageUrl: "img/MATLAB-1.webp",
    category: "ELECTRICAL CAD",
    description:
      "Used by engineers and scientists for iterative analysis and design processes.",
    link: "/Matlabelectrical",
  },
  {
    appId: 25,
    appName: "PLC",
    imageUrl: "img/PLC-1.webp",
    category: "ELECTRICAL CAD",
    description:
      "(PLCs) are one of the most useful technologies in the industries for automation.",
    link: "/Plc",
  },
  {
    appId: 26,
    appName: "Fullstack Developer",
    imageUrl: "img/full-stack.webp",
    category: "IT COURSES",
    description:
      "To design and develop web-based, network-centric or enterprise applications",
    link: "/Fullstack",
  },
  {
    appId: 27,
    appName: "Cyber Security",
    imageUrl: "img/Cyber-Security.webp",
    category: "IT COURSES",
    description:
      "It is the practice of defending computers and servers, mobile devices, etc from malicious attacks",
    link: "/CyberSecurity",
  },
  {
    appId: 28,
    appName: "BIM",
    imageUrl: "img/bim.webp",
    category: "INTERIOR & BIM",
    description: "BIM training with Revit Architecture, Structure & MEP and practical 3D modeling.",
    link: "/civil-architecture",
  },
  {
    appId: 29,
    appName: "Interior Design",
    imageUrl: "img/interior-designing.webp",
    category: "INTERIOR & BIM",
    description:
      "Interior design training with AutoCAD, SketchUp, 3ds Max, V-Ray & Lumion for 2D drafting and 3D visualization.",
    link: "/civil-design",
  },
  {
    appId: 30,
    appName: "C Programming",
    imageUrl: "img/programming.webp",
    category: "IT COURSES",
    description: "Learn programming concepts, logic building, and software development using modern programming languages.",
    link: "/CProgramming",
  },
  {
    appId: 31,
    appName: "Accounting",
    imageUrl: "img/accounting.webp",
    category: "IT COURSES",
    description: "Learn accounting fundamentals including bookkeeping, financial statements, and accounting software.",
    link: "/Accounting",
  },
  {
    appId: 32,
    appName: "Graphic Design",
    imageUrl: "img/graphic-design.webp",
    category: "IT COURSES",
    description: "Learn visual communication, typography, color theory, and digital design tools.",
    link: "/GraphicDesign",
  },
  {
    appId: 33,
    appName: "Data Visualisation",
    imageUrl: "img/data-visualisation.webp",
    category: "IT COURSES",
    description: "Learn how to represent data visually using charts, dashboards, and data analytics tools.",
    link: "/DataVisualisation",
  },
  {
    appId: 34,
    appName: "Software Testing",
    imageUrl: "img/software-testing.webp",
    category: "IT COURSES",
    description: "Understand software testing methodologies including manual and automated testing techniques.",
    link: "/SoftwareTesting",
  },
  {
    appId: 35,
    appName: "Web Development",
    imageUrl: "img/web-development.webp",
    category: "IT COURSES",
    description: "Learn how to build modern websites using HTML, CSS, JavaScript and backend technologies.",
    link: "/WebDevelopment",
  },
  {
    appId: 36,
    appName: "Database Management",
    imageUrl: "img/database-management.webp",
    category: "IT COURSES",
    description: "Learn database design, SQL queries, data storage, and management of relational databases.",
    link: "/DatabaseManagement",
  },
  {
    appId: 37,
    appName: "UI & UX",
    imageUrl: "img/ui-ux.webp",
    category: "IT COURSES",
    description: "Learn user interface and user experience design principles to create user-friendly digital products.",
    link: "/UIUX",
  },
  {
    appId: 38,
    appName: "PhotoShop",
    imageUrl: "img/photoshop.webp",
    category: "IT COURSES",
    description: "Graphic design software used for enhancing and editing images, including architectural visualizations.",
    link: "/PhotoShop",
  },
  {
    appId: 39,
    appName: "Corel Draw",
    imageUrl: "img/corel-draw.webp",
    category: "IT COURSES",
    description: "Learn vector graphic design, illustration, and professional layout design using CorelDraw.",
    link: "/CorelDraw",
  },
  {
    appId: 40,
    appName: "Canva",
    imageUrl: "img/canva.webp",
    category: "IT COURSES",
    description: "Create professional graphics, social media designs, and presentations using Canva.",
    link: "/Canva",
  },
  {
    appId: 41,
    appName: "CSS",
    imageUrl: "img/css.webp",
    category: "IT COURSES",
    description: "Learn Cascading Style Sheets to design responsive and visually appealing websites.",
    link: "/CSS",
  },
  {
    appId: 42,
    appName: "Figma",
    imageUrl: "img/figma.webp",
    category: "IT COURSES",
    description: "Learn interface design, prototyping, and collaborative design using Figma.",
    link: "/Figma",
  },
  {
    appId: 43,
    appName: "HTML 5",
    imageUrl: "img/html5.webp",
    category: "IT COURSES",
    description: "Learn HTML5 to build structured and semantic web pages for modern websites.",
    link: "/HTML5",
  },
  {
    appId: 44,
    appName: "C++ Programming",
    imageUrl: "img/cpp.webp",
    category: "IT COURSES",
    description: "Learn object-oriented programming, data structures, and application development using C++.",
    link: "/CppProgramming",
  },
  {
    appId: 45,
    appName: "C# Programming",
    imageUrl: "img/csharp.Webp",
    category: "IT COURSES",
    description: "Learn C# programming for building desktop applications, web applications, and .NET software.",
    link: "/CSharpProgramming",
  },
];

// ── Wrapper injects location into the class component ──────────────────────
class AppStoreClass extends Component {
  constructor(props) {
    super(props);
    // Read tabId passed via navigate(state) from Service.jsx
    const passedTabId = props.location?.state?.activeTabId;
    this.state = {
      searchInput: "",
      activeTabId: passedTabId || tabsList[0].tabId,
    };
  }

  setActiveTabId = (tabId) => {
    this.setState({ activeTabId: tabId });
  };

  onChangeSearchInput = (event) => {
    this.setState({ searchInput: event.target.value });
  };

  getActiveTabApps = (searchedApps) => {
    const { activeTabId } = this.state;
    return searchedApps.filter(
      (eachSearchedApp) => eachSearchedApp.category === activeTabId
    );
  };

  getSearchResults = () => {
    const { searchInput } = this.state;
    return appsList.filter((eachApp) =>
      eachApp.appName.toLowerCase().includes(searchInput.toLowerCase())
    );
  };

  render() {
    const { searchInput, activeTabId } = this.state;
    const searchResults = this.getSearchResults();
    const filteredApps = this.getActiveTabApps(searchResults);

    return (
     <Fragment>
        <div>
          <img
            src="img/footer1.webp"
            alt="Slide Image"
            className="img-fluid w-100"
            style={{ height: "300px", width: "800px" }}
          />
          <nav aria-label="breadcrumb" className="mt-3">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Courses
              </li>
            </ol>
          </nav>
        </div>

        <div className="app-container py-1" style={{ marginTop: "-50px" }}>
          <div className="app-store">
            <h1 className="heading">OUR COURSES</h1>
            <div className="">
              <input
                type="search"
                placeholder="Search"
                className="search-input"
                value={searchInput}
                onChange={this.onChangeSearchInput}
              />
              <img
                src={SEARCH_ICON_URL}
                alt="search icon"
                className="search-icon"
              />
            </div>

            {/* ✅ Scrollable wrapper — makes tabs swipeable on mobile */}
            <div className="tabs-scroll-wrapper d-flex align-items-md-center justify-content-md-center">
              <ul className="tabs-list ">
                {tabsList.map((eachTab) => (
                  <TabItem
                    key={eachTab.tabId}
                    tabDetails={eachTab}
                    setActiveTabId={this.setActiveTabId}
                    isActive={activeTabId === eachTab.tabId}
                  />
                ))}
              </ul>
            </div>

            <ul className="apps-list">
              {filteredApps.map((eachApp) => (
                <AppItem key={eachApp.appId} appDetails={eachApp} />
              ))}
            </ul>
          </div>
        </div>
      </Fragment>
      
    );
  }
}

// Functional wrapper to pass location hook into class component
function AppStore(props) {
  const location = useLocation();
  return <AppStoreClass {...props} location={location} />;
}

export default AppStore;